"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _clsx = _interopRequireDefault(require("clsx"));
var _styles = require("@material-ui/core/styles");
var _core = require("@material-ui/core");
var __jsx = _react.default.createElement;
var useStyles = (0, _styles.makeStyles)(function (theme) {
  return {
    breadcrumbItem: {
      fontSize: 'inherit'
    }
  };
});
var BreadcrumbItem = function BreadcrumbItem(_ref) {
  var url = _ref.url,
    title = _ref.title,
    active = _ref.active,
    nonClickable = _ref.nonClickable,
    titleEng = _ref.titleEng,
    handleBreadcrumbClick = _ref.handleBreadcrumbClick;
  var classes = useStyles();

  // To avoid refactor TagBasedBreadcrumb.java, we are creating the logic in FE
  var isLinkDisabled = nonClickable === null ? active : nonClickable;
  return __jsx(_core.Typography, (0, _extends2.default)({
    component: isLinkDisabled ? 'span' : 'a',
    href: !isLinkDisabled ? url : '',
    className: (0, _clsx.default)(classes.breadcrumbItem, 'current-link'),
    "data-active": active,
    dangerouslySetInnerHTML: {
      __html: title
    }
  }, !isLinkDisabled && {
    onClick: function onClick() {
      handleBreadcrumbClick(titleEng, url);
    }
  }));
};
var _default = BreadcrumbItem;
exports.default = _default;